import { render, staticRenderFns } from "./LicenseStatus.vue?vue&type=template&id=096c273a&scoped=true&"
import script from "./LicenseStatus.vue?vue&type=script&lang=js&"
export * from "./LicenseStatus.vue?vue&type=script&lang=js&"
import style0 from "./LicenseStatus.vue?vue&type=style&index=0&id=096c273a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c273a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
